import {useGetAutoDeliveryDetailsExtended} from '@/api/consumerApi';
import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import routePaths from '@/consts/route/routePaths';
import AutoDeliveryOnHoldButton from '@/views/AutoDelivery/AutoDeliveryOnHold/AutoDeliveryOnHoldButton';
import AutoDeliveryOnHoldInfoBox from '@/views/AutoDelivery/AutoDeliveryOnHold/AutoDeliveryOnHoldInfoBox';
import AutoDeliveryStatusTitle from '@/views/AutoDelivery/AutoDeliveryStatusTitle';

import AutoDeliveryDetailsFooter from '../components/AutoDeliveryDetailsFooter';
import AutoDeliveryOrder from '../components/AutoDeliveryOrder';
import AutoDeliveryOrderAddress from '../components/AutoDeliveryOrderAddress';
import AutoDeliveryOrderHeader from '../components/AutoDeliveryOrderHeader';
import AutoDeliveryPageDesktopLayout from '../components/AutoDeliveryPageDesktopLayout';

const StatusOnHoldDesktop = ({amplitudeEvent}) => {
    const {
        data: {
            autoDelivery: {statusUpdateReason},
            order: {deliveryAddress, products},
        },
    } = useGetAutoDeliveryDetailsExtended();

    return (
        <AutoDeliveryPageDesktopLayout>
            <AutoDeliveryPageDesktopLayout.Start>
                <AutoDeliveryStatusTitle
                    className='md:text-36'
                    title={<AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='autoDeliveryOnHoldTitle' />}
                />
                <AutoDeliveryOnHoldInfoBox statusUpdateReason={statusUpdateReason} className='mt-8 ml:bg-romance'>
                    <AutoDeliveryOnHoldButton
                        statusUpdateReason={statusUpdateReason}
                        amplitudeEvent={amplitudeEvent}
                        className='mt-0'
                    />
                </AutoDeliveryOnHoldInfoBox>
                <AutoDeliveryOrder className='mt-8 snap-start p-0' products={products}>
                    <AutoDeliveryOrderHeader isEditAllowed renderAs='h2' />
                </AutoDeliveryOrder>
                <AutoDeliveryDetailsFooter />
            </AutoDeliveryPageDesktopLayout.Start>
            <AutoDeliveryPageDesktopLayout.End>
                <AutoDeliveryOrderAddress className='p-0' address={deliveryAddress} />
            </AutoDeliveryPageDesktopLayout.End>
        </AutoDeliveryPageDesktopLayout>
    );
};

export default StatusOnHoldDesktop;
